module.exports = __webpack_public_path__ + "img/logo-new.605cb1ac.svg";